import { mapState } from 'vuex';
import ApiService from '@/services/apiService';

export default {
  data() {
    return {
      accountFilterReady: false,
      selectedAccounts: [],

      searchItems: [],

      searchTags: [],
      searchZones: [],
      ddrKeys: [],
      ddrValues: [],
    };
  },
  computed: {
    ...mapState('app', ['language']),
    searchTypes() {
      return [
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.title'),
          param: 'title',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.id'),
          param: 'id',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.tag'),
          param: 'tag',
          searchHandler: async (searchFor, page, pageSize) => {
            const result = await this.searchForTags(searchFor, page, pageSize);
            return {
              totalCount: result.totalCount,
              items: result.tagList,
            };
          },
        },
        {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.dataRouting.referenceId'),
          param: 'ddrDestination',
          searchHandler: async (_, page, pageSize, entityType, key) => {
            const result = await this.searchForDdrSettings(page, pageSize, entityType, key);
            return {
              totalCount: result.totalcount,
              items: result.entities,
            };
          },
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.keyValue'),
          param: 'keyValue',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props.zone'),
          param: 'zone',
          searchHandler: async () => {
            const result = await this.searchForZones();
            return {
              totalCount: result.totalCount,
              items: result.zoneList,
            };
          },
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['floorDtwin.name'],
          param: 'floorDtwin.name',
        },
        {
          text: this.$i18n_t('DigitalTwin.VirtualDevice.props')['floorDtwin.number'],
          param: 'floorDtwin.number',
        },
        {
          text: this.$i18n_t('DigitalTwin.DigitalTwin.twinTemplates.title'),
          param: 'twinTemplate',
        },
      ];
    },
  },
  watch: {
    language() {
      (this.searchTypes.find((item) => item.param === 'tag') || {}).items = this.tagList;
      (this.searchTypes.find((item) => item.param === 'zone') || {}).items = this.zoneList;
      (this.searchTypes.find((item) => item.param === 'ddrDestination') || {}).items = this.ddrKeys = this.ddrValues;
    },
  },
  methods: {
    searchUpdated(search) {
      this.searchItems = search;
      this.fetchList(true);
    },
    async searchForTags() {
      const result = await ApiService.digitalTwinFetchTagsAndZones(this);
      result.tagList = result.tagList.map((tag) => {
        return { value: tag, text: tag };
      });

      return result;
    },
    async searchForZones() {
      const result = await ApiService.digitalTwinFetchTagsAndZones(this);
      result.zoneList = result.zoneList.map((zone) => {
        return { value: zone, text: zone };
      });

      return result;
    },
    async searchForDdrSettings(page, pageSize, entityType, key) {
      const result = await ApiService.fetchDdrSettings({
        entityType,
        offset: page * pageSize,
        limit: pageSize,
        key,
        accounts: (this.selectedAccounts || []).map((acc) => acc.id),
      });
      result.entities = result.entities.map((e) => {
        return { value: e, text: e };
      });
      return result;
    },
  },
};
